import React, { useEffect, useState, useRef, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Grid,
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  IconButton,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextareaAutosize,
  Backdrop,
  CircularProgress,
  Chip,
  Tooltip,
  Typography, Popover
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CommentIcon from "@mui/icons-material/Comment";
import { useSelector, useDispatch } from "react-redux";
import {
  GetWeekStatus,
  setState,
  getQuotaDetails,
  GetQuotaDetailsForScenario,
  PostOrderDecision,
  DoNothingMarked,
  SubmitModification,
  GetBlockedCustomersConsumption,
  RecallModification,
  StickToQuota,
  GetBlockedCustomersConsumptionforDecision,
  GetBlockedCustomersConsumptionforMSQDecision,
} from "../reviewSlice";
import LabelImportantRoundedIcon from "@mui/icons-material/LabelImportantRounded";
import DownloadDoneRoundedIcon from "@mui/icons-material/DownloadDoneRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { green, orange, red, grey, blue } from "@mui/material/colors";
import CollapseSection from "../../../components/ui/CollapseSection";
import Modification from "./Modification";
import ModifyOrders from "./ModifyOrders";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltTwoToneIcon from '@mui/icons-material/FilterAltTwoTone';
import ExportIcons from './ExportIcons';

const DisplayComments = (params) => {
  const [displayComments, setDisplayComments] = useState("");
  const [userComments, setUserComments] = useState("");
  const [open, setOpen] = useState(false);
  const desiredcolor =
    params.comments.length > 0 &&
    params.comments != "Default Customer quota record"
      ? "blue"
      : "black";

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleConfirm = () => {
    setDisplayComments(userComments);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)} title={params.comments}>
        {params.comments ? (
          <CommentIcon title={params.comments} sx={{ color: "#007DC3" }} />
        ) : (
          <CommentIcon />
        )}
      </IconButton>

      <Dialog
        disableEnforceFocus
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TextareaAutosize
              onChange={(event) => setUserComments(event.target.value)}
              aria-label="minimum height"
              minRows={5}
              readOnly
              placeholder="Comments"
              style={{ width: 500, fontSize: 18 }}
              defaultValue={params.comments}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={handleClose}
            size="small"
            style={{
              background: "#286aa6",
              color: "white",
              borderRadius: "4px",
            }}
          >
            Cancel
          </Button>
          {/* <Button
                        autoFocus
                        variant="contained"
                        onClick={handleConfirm}
                        size="small"
                        style={{
                            background: "#286aa6",
                            color: "white",
                            borderRadius: "4px",
                        }}
                    >
                        Save Changes
                    </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

const QuotaandConsumption = ({ setIsModificationOpened }) => {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorType, setAnchorType] = useState(null);
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchProduct, setSearchProduct] = useState("");
  //const [pageSize, setPageSize] = React.useState(20);
  const [rows, setRows] = useState([]);
  const QCRef = useRef(null);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [isDisplayBlockedCustomers, setIsDisplayBlockedCustomers] =
    useState(false);
  const [currentWeek, setCurrentWeek] = useState(0);
  const [isCollapseOpened, setIsCollapseOpened] = useState(false);
  const theme = useTheme();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const dispatch = useDispatch();
  const review = useSelector((state) => state.review);
  const {
    isLoading,
    getQuotaDetails,
    ModifiedList,
    selectedCountryID,
    selectedScenario,
    selectedScenarioID,
    selectedScenarioName,
    selectedQuotaID,
    clearQCTable,
    getWeekStatus,
    quotaConsumptionTableState,
    QCcustomerSearch,
    QCproductSearch,
    RecallList,
    isRecallClicked,
    getScenarios,
    customerListForDecision,
    omIsDisplayBlocked,
    onUnblockClicked,
    onMSQClicked,
    customerTrustLevel,
    customerTypes
  } = review;

  const [open, setOpen] = useState(false);
  const [filterVisible, setFilterVisible] = useState(true);
  const [customerTrustLvl, setcustomerTrustLvl] = React.useState([]);
  const [customerType, setcustomerType] = React.useState([]);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseTrust = () => {
    setAnchorEl(null);
  };
  const handleCloseType = () => {
    setAnchorType(null);
  };

  function getChipProps(params) {
    if (params.value ===  "Low") {
      return {
        label: "Low",
        style: {
          fontWeight: "bold",
          borderColor: red[500],
          backgroundColor: red[50],
          color: red[500],
        },
      };
    } else if (params.value === "Medium") {
      return {
        label: "Medium",
        style: {
          fontWeight: "bold",
          borderColor: orange[500],
          backgroundColor: orange[50],
          color: orange[500],
        },
      };
    } else if (params.value === "High") {
      return {
        label: "High",
        style: {
          fontWeight: "bold",
          borderColor: green[500],
          backgroundColor: green[50],
          color: green[500],
        },
      };
    } else {
      return {
        label: "Other",
        style: {
          fontWeight: "bold",
          borderColor: blue[500],
          backgroundColor: blue[50],
          color: blue[500],
        },
      };
    }
  }

  useEffect(() => {
    if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
      setCurrentWeek(1);
    } else if (getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly") {
      if (getWeekStatus.chkFirstHalf == true) {
        setCurrentWeek(1);
      } else if (getWeekStatus.chkSecondHalf == true) {
        setCurrentWeek(2);
      }
    } else {
      if (getWeekStatus.chkMonth == true) {
        if (getWeekStatus.chkWeek1 == true) {
          setCurrentWeek(1);
        } else if (getWeekStatus.chkWeek2 == true) {
          setCurrentWeek(2);
        } else if (getWeekStatus.chkWeek3 == true) {
          setCurrentWeek(3);
        } else if (getWeekStatus.chkWeek4 == true) {
          setCurrentWeek(4);
        } else if (getWeekStatus.chkWeek5 == true) {
          setCurrentWeek(5);
        }
      } else {
        setCurrentWeek(0);
      }
    }
  }, [getWeekStatus]);
  
  const handleHeaderClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleHeaderTypeClick = (event) => {
    setAnchorType(anchorType ? null : event.currentTarget);
  };

  const handleCheckboxChange = (category) => {
    setcustomerTrustLvl((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };

  const handleCheckboxTypeChange = (category) => {
    setcustomerType((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };



  const w = 95;
  const columns = [
    {
      field: "customerName",
      headerName: "Customer / CG",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "sapCustomerNumber",
      headerName: "Customer Number",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "skuName",
      headerName: "SKU / PG",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "skuNumb",
      headerName: "SKU Number",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "customerType",
      headerName: "Customer Type",
      flex : 1,
      minWidth: 170,
      sortable: false,
      renderHeader: () => (
        <div>
        <div onClick={handleHeaderTypeClick} 
        style={{ display: 'flex', justifyContent: 'space-between', wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '14px', cursor: 'pointer', lineHeight: '1.2' }}> 
        <span>Customer Type  </span> 
        {customerType?.length === 0 &&<FilterAltOutlinedIcon style={{ color: '#bcbcba', fontSize : '20px'}} />}
        {customerType?.length > 0 && <FilterAltTwoToneIcon style={{ color: '#6f6f6c', fontSize : '20px'}} />}
        </div>
        <Popover
        open={Boolean(anchorType)}
        anchorEl={anchorType}
        onClose={handleCloseType}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: 16, maxHeight: '200px', overflowY: 'auto'}}>
          {customerTypes.map((category) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={customerType.includes(category)}
                  onChange={() => handleCheckboxTypeChange(category)}
                />
              }
              label={category}
              key={category}
              style={{ display: 'block' }}
            />
          ))}
        </div>
      </Popover>
      </div>
      ),
    },
    {
      field: "customerTrustLevel",
      headerName: "Customer trust level",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderHeader: () => (
        <div>
        <div onClick={handleHeaderClick} 
        style={{ display: 'flex', justifyContent: 'space-between', wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '14px', cursor: 'pointer', lineHeight: '1.2' }}> 
        <span>Customer Trust Level</span> 
        {customerTrustLvl?.length === 0 &&<FilterAltOutlinedIcon style={{ color: '#bcbcba', fontSize : '25px', paddingTop : '5px'}} />}
        {customerTrustLvl?.length > 0 && <FilterAltTwoToneIcon style={{ color: '#6f6f6c', fontSize : '25px', paddingTop : '5px'}} />}
        </div>

        <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseTrust}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: 16, maxHeight: '200px', overflowY: 'auto' }}>
          {customerTrustLevel.map((category) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={customerTrustLvl.includes(category)}
                  onChange={() => handleCheckboxChange(category)}
                />
              }
              label={category}
              key={category}
              style={{ display: 'block' }}
            />
          ))}
        </div>
      </Popover>
      </div>
      ),
      renderCell: (params) => {
        return (
          <Chip
            sx={{ height: "1.2rem" }}
            variant="outlined"
            {...getChipProps(params)}
          />
        );
      },
      // renderCell: (cellValues) => {

      //     let iconStyle = "";
      //     if (cellValues.value === "High") {
      //         iconStyle = "green";
      //     } else if (cellValues.value === "Medium") {
      //         iconStyle = "orange";
      //     } else if (cellValues.value === "Low") {
      //         iconStyle = "red";
      //     } else if (cellValues.value === "Others") {
      //         iconStyle = "blue";
      //     } else {
      //         iconStyle = "displayNone";
      //     }
      //     console.log(iconStyle)
      //     return (
      //         <span title={cellValues.value}>
      //             <FiberManualRecordIcon color={iconStyle} />
      //         </span>
      //     );
      // },
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip
          title={params.row.salesOrder.toString()}
          sx={{ fontSize: "16px", backgroundColor: "white", color: "black" }}
        >
          <span>
            {params.value === "Blocked and reviewed"
              ? "Reviewed"
              : params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "unusedQuota",
      headerName: "Unused Quota - Previous Period",
      minWidth: 100,
      width: 130,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      },
    },
    {
      field: "quota",
      headerName: "Quota",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      },
    },
    {
      field: "consumption",
      headerName: "Consumption",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      },
    },
    {
      field: "availableQuota",
      headerName: "Available Quota",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        let availableQuota = 0;
        if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
          availableQuota = params.row.weekly1 - params.row.consumption;
        } else if (
          getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly"
        ) {
          if (currentWeek === 1) {
            availableQuota = params.row.weekly1 - params.row.consumption;
          } else {
            availableQuota = params.row.weekly2 - params.row.consumption;
          }
        } else {
          if (currentWeek === 1) {
            availableQuota = params.row.weekly1 - params.row.consumption;
          } else if (currentWeek === 2) {
            availableQuota = params.row.weekly2 - params.row.consumption;
          } else if (currentWeek === 3) {
            availableQuota = params.row.weekly3 - params.row.consumption;
          } else if (currentWeek === 4) {
            availableQuota = params.row.weekly4 - params.row.consumption;
          } else {
            availableQuota = params.row.weekly5 - params.row.consumption;
          }
        }
        return availableQuota;
      },
    },
    {
      field: "intendedQuantity",
      headerName: "Intended Quantity",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      },
    },
    {
      field: "modifiedOrderQtyUoM",
      headerName: "Modified Quantity",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      },
    },
    {
      field: "weekly1",
      headerName:
        getQuotaDetails?.depletionModel?.toLowerCase() === "none"
          ? "Final Quota"
          : getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly"
          ? "First Half"
          : "Week1",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        return (
          <div>
            <span>{cellValues.value?.toLocaleString()}</span>
            <br />
            <span style={{ color: "blue" }}>
              {cellValues.value?.toLocaleString()}
            </span>
          </div>
        );
      },
    },
    {
      field: "weekly2",
      headerName:
        getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly"
          ? "Second Half"
          : "Week2",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        let weekly1 = cellValues.row.weekly1;
        let weekly2 = cellValues.row.weekly2;
        let diff = weekly2 - weekly1;

        return (
          <div>
            <span>{cellValues.value?.toLocaleString()}</span>
            <br />
            <span style={{ color: "blue" }}>{diff?.toLocaleString()}</span>
          </div>
        );
      },
    },
    {
      field: "weekly3",
      headerName: "Week3",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        let weekly2 = cellValues.row.weekly2;
        let weekly3 = cellValues.row.weekly3;
        let diff = weekly3 - weekly2;

        return (
          <div>
            <span>{cellValues.value?.toLocaleString()}</span>
            <br />
            <span style={{ color: "blue" }}>{diff?.toLocaleString()}</span>
          </div>
        );
      },
    },
    {
      field: "weekly4",
      headerName: "Week4",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        let weekly3 = cellValues.row.weekly3;
        let weekly4 = cellValues.row.weekly4;
        let diff = weekly4 - weekly3;

        return (
          <div>
            <span>{cellValues.value?.toLocaleString()}</span>
            <br />
            <span style={{ color: "blue" }}>{diff?.toLocaleString()}</span>
          </div>
        );
      },
    },
    {
      field: "weekly5",
      headerName: "Week5",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        let weekly4 = cellValues.row.weekly4;
        let weekly5 = cellValues.row.weekly5;
        let diff = weekly5 - weekly4;

        return (
          <div>
            <span>{cellValues.value?.toLocaleString()}</span>
            <br />
            <span style={{ color: "blue" }}>{diff?.toLocaleString()}</span>
          </div>
        );
      },
    },
    {
      field: "todaysConsumption",
      headerName: "Today's Consumption",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      },
    },
    {
      field: "yesterdaysConsumption",
      headerName: "Yesterday's Consumption",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      },
    },
    // {
    //     field: "deliveredQty",
    //     headerName: "Delivered Quantity",
    //     flex: 1, minWidth: 100,
    // },
    {
      field: "stickToQuota",
      editable: false,
      headerName: "AT-STQ",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        let checked = cellValues.row.stickToQuota;
        const label = { inputProps: { "aria-label": "Checkbox" } };
        return checked === 1 ? (
          <Checkbox {...label} defaultChecked disabled />
        ) : (
          <Checkbox {...label} disabled />
        );
      },
    },
    {
      field: "customerComments",
      headerName: "Comments",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        return <DisplayComments readonly comments={cellValues.value} />;
      },
    },
  ];

  const handleSearchCustomer = (e) => {
    const value = e.target.value;
    setSearchCustomer(value);
  };

  const handleSearchProduct = (e) => {
    const value = e.target.value;
    setSearchProduct(value);
  };
  useEffect(() => {
    setSearchCustomer(QCcustomerSearch);
    setSearchProduct(QCproductSearch);
  }, [QCcustomerSearch, QCproductSearch]);

  const handleRetrive = (e, isRecall) => {
    debugger;
    dispatch(setState("isModifyClicked", true));
    dispatch(setState("onUnblockClicked", false));
    dispatch(setState("onMSQClicked", false));
    dispatch(setState("isCurrentWeekRowChanged", false));
    dispatch(setState("customerListForDecision", []));
    dispatch(setState("customerListForDecisionSubmission", []));
    if (isRecall) {
      if (getQuotaDetails?.quotaCusumptionCustomers?.length > 0) {
        let getRecallModList = JSON.parse(JSON.stringify(getQuotaDetails));
        let consumptionList = getRecallModList?.quotaCusumptionCustomers;
        if (consumptionList?.length > 0) {
          for (let i = 0; i < RecallList?.length; i++) {
            let index = consumptionList.findIndex(
              (x) => x.customerQuotaID === RecallList[i]?.customerQuotaID
            );
            if (index !== -1) {
              consumptionList[index].newFinalQuota.weekly1 =
                RecallList[i]?.weekly1;
              consumptionList[index].newFinalQuota.weekly2 =
                RecallList[i]?.weekly2;
              consumptionList[index].newFinalQuota.weekly3 =
                RecallList[i]?.weekly3;
              consumptionList[index].newFinalQuota.weekly4 =
                RecallList[i]?.weekly4;
              consumptionList[index].newFinalQuota.weekly5 =
                RecallList[i]?.weekly5;
              consumptionList[index].newFinalQuota.customerComments =
                RecallList[i]?.customerComments;
            }
          }
        }
        getRecallModList.quotaCusumptionCustomers = consumptionList;
        dispatch(setState("ModifiedList", getRecallModList));
        dispatch(
          setState(
            "updatedWeeklyData",
            getRecallModList?.quotaCusumptionCustomers
          )
        );
        if (rowSelectionModel?.length === quotaConsumptionTableState?.length) {
          let List = [];
          for (let i = 0; i < quotaConsumptionTableState?.length; i++) {
            let index = getRecallModList.quotaCusumptionCustomers.findIndex(
              (x) =>
                x.customerQuotaID ===
                quotaConsumptionTableState[i]?.customerQuotaID
            );
            List.push(getRecallModList.quotaCusumptionCustomers[index]);
          }
          dispatch(setState("modifyList", List));
          dispatch(setState("CustomerSearchTxt", searchCustomer));
          dispatch(setState("ProductSearchTxt", searchProduct));
          dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
        } else {
          dispatch(
            setState("modifyList", getRecallModList?.quotaCusumptionCustomers)
          );
          dispatch(setState("CustomerSearchTxt", ""));
          dispatch(setState("ProductSearchTxt", ""));
          dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
        }
      }
      dispatch(setState("isRecallClicked", false));
    } else {
      dispatch(setState("ModifiedList", getQuotaDetails));
      dispatch(
        setState("updatedWeeklyData", getQuotaDetails?.quotaCusumptionCustomers)
      );
      if (rowSelectionModel?.length === quotaConsumptionTableState?.length) {
        dispatch(setState("modifyList", quotaConsumptionTableState));
        dispatch(setState("CustomerSearchTxt", searchCustomer));
        dispatch(setState("ProductSearchTxt", searchProduct));
        dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      } else {
        dispatch(
          setState("modifyList", getQuotaDetails?.quotaCusumptionCustomers)
        );
        dispatch(setState("CustomerSearchTxt", ""));
        dispatch(setState("ProductSearchTxt", ""));
        dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      }
    }
    dispatch(setState("displayModification", true));
    setIsModificationOpened(true);
  };

  const handleRecallModification = () => {
    dispatch(setState("isModifyClicked", true));
    dispatch(setState("isRecallClicked", true));
    dispatch(RecallModification(getQuotaDetails?.quotaID)).then(() => {
      dispatch(setState("displayModification", true));
      setIsModificationOpened(true);
    });
  };

  // useEffect(() => {
  //     if (getQuotaDetails) {
  //         console.log(getQuotaDetails.quotaCusumptionCustomers)
  //         setRows(getQuotaDetails.quotaCusumptionCustomers);
  //     }
  // }, [getQuotaDetails])

  useEffect(() => {
    if (clearQCTable) {
      setRows([]);
      dispatch(setState("clearQCTable", false));
    }
  }, [clearQCTable]);

  useEffect(() => {
    if (isRecallClicked) {
      if (RecallList.length > 0) {
        handleRetrive([], true);
      }
    }
  }, [RecallList]);

  useEffect(() => {
    if (rows?.length > 0) {
      dispatch(setState("quotaConsumptionTableState", rows));
      if (isDisplayBlockedCustomers) {
        debugger;
        dispatch(setState("modifyList", rows));
        let val = getQuotaDetails?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          retVal = item.orderStatus.toLowerCase().includes("blocked") || item.customerName.toLowerCase().includes("buffer"); ;
          return retVal;
        });
        dispatch(setState("modifyList", val));
        dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      } else {
        dispatch(
          setState("modifyList", getQuotaDetails?.quotaCusumptionCustomers)
        );
        dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      }
    }
  }, [rows]);

  const filteredRow=()=>{
    setRows((prevVal) => {
      let val = getQuotaDetails?.quotaCusumptionCustomers?.filter(
        (item) => {
          let retVal = false;
          if (
            item.customerName !== undefined &&
            item.sapCustomerNumber !== undefined &&
            searchCustomer !== undefined &&
            item.skuName !== undefined &&
            item.skuNumb !== undefined
          ) {
            if (isDisplayBlockedCustomers) {
              debugger;
              retVal =
                (customerType.length === 0 || customerType.some(type => item.customerType.toLowerCase().includes(type.toLowerCase()))) &&
                (customerTrustLvl.length === 0 || customerTrustLvl.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
                (item.orderStatus.toLowerCase().includes("blocked") || item.customerName.toLowerCase().includes("buffer")) &&
                (item.customerName
                  .toLowerCase()
                  .includes(searchCustomer.toLowerCase()) ||
                  item.sapCustomerNumber
                    .toLowerCase()
                    .includes(searchCustomer.toLowerCase())) &&
                (item.skuName
                  .toLowerCase()
                  .includes(searchProduct?.toLowerCase()) ||
                  item.skuNumb
                    .toLowerCase()
                    .includes(searchProduct?.toLowerCase()))
                    
                    ;
            } else {
              retVal =
              (customerType.length === 0 || customerType.some(type => item.customerType.toLowerCase().includes(type.toLowerCase()))) &&
              (customerTrustLvl.length === 0 || customerTrustLvl.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
                (item.customerName
                  .toLowerCase()
                  .includes(searchCustomer.toLowerCase()) ||
                  item.sapCustomerNumber
                    .toLowerCase()
                    .includes(searchCustomer.toLowerCase())) &&
                (item.skuName
                  .toLowerCase()
                  .includes(searchProduct?.toLowerCase()) ||
                  item.skuNumb
                    .toLowerCase()
                    .includes(searchProduct?.toLowerCase()));
            }
          } else {
            return retVal;
          }
          return retVal;
        }
      );
      return val;
    });
  }

  const handleOnCustomerProductChange = (searchCustomer, searchProduct) => {
    if(searchProduct === undefined)setSearchProduct("");
    if(searchCustomer === undefined)setSearchCustomer("");
    filteredRow();
  };
  useEffect(() => {
    handleOnCustomerProductChange(searchCustomer, searchProduct);
  }, [searchCustomer]);

  useEffect(() => {
    handleOnCustomerProductChange(searchCustomer, searchProduct);
  }, [searchProduct]);

  useEffect(() => {
    dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
    filteredRow();
  }, [isDisplayBlockedCustomers]);

  useEffect(() => {
    filteredRow();
  }, [customerType, customerTrustLvl]);

  /* Generate a random value for unique value every time */

  // function generateRandom() {
  //     var length = 8,
  //         charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
  //         retVal = "";
  //     for (var i = 0, n = charset.length; i < length; ++i) {
  //         retVal += charset.charAt(Math.floor(Math.random() * n));
  //     }
  //     return retVal;
  // }

  useEffect(() => {
    if (rowSelectionModel.length >= 0) {
      //console.log(rowSelectionModel);
      dispatch(setState("checkedCustomersList", rowSelectionModel));
    }
  }, [rowSelectionModel]);

  useEffect(() => {
    if (getQuotaDetails.quotaCusumptionCustomers) {
      setcustomerType([]);
      setcustomerTrustLvl([]);
      setRows(getQuotaDetails.quotaCusumptionCustomers);
      handleOnCustomerProductChange(searchCustomer, searchProduct);
    }
    scrollToThirdDataGrid();
  }, [getQuotaDetails.quotaCusumptionCustomers]);

  const scrollToThirdDataGrid = () => {
    setTimeout(() => {
      if (QCRef.current) {
        QCRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 1000);
  };

  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };
  const SaveOrderDecision = (code) => {
    let decisionCode = "";
    let desSucmessage = "";
    let desSucPartmessage = "";
    let obj = {};
    let customerList = [];
    const newObj = {
      scenarioId: selectedScenarioID,
      quotaId: selectedQuotaID,
    };
    if (code == "stick") {
      decisionCode = "SQ";
      desSucmessage = "Stick to quota orders decision updated successfully.";
      desSucPartmessage =
        "Stick to quota Orders decision updated successfully for some of the selected customer(s)";
    } else if (code == "nothing") {
      decisionCode = "ND";
      desSucmessage = "Do nothing orders decision updated successfully.";
      desSucPartmessage =
        "Do nothing Orders decision updated successfully for some of the selected customer(s)";
    }
    // console.log(rowSelectionModel);
    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (row["orderStatus"].toLowerCase() == "blocked") {
        customerList.push(row.customerQuotaID);
      }
      if(row.isBlockedOverNormal === 1 && row["orderStatus"].toLowerCase() == "blocked"){
        showMessage("Decision cannot be made as a blocked order has been placed above a normal order.", "info");
        return;
      }
      // customerList.push(row["id"]);
    }
    if (customerList.length == 0) {
      console.log("Please select blocked customer(s)");
      showMessage("Please select blocked customer(s)", "info");
      return;
    } else {
      obj.countryId = getScenarios.find(
        (x) => x.scenarioID === newObj.scenarioId
      ).geoID;
      obj.scenarioId = selectedScenarioID;
      obj.sceanrioName = selectedScenarioName;
      obj.blockedcustomers = customerList;
      obj.quotaId = selectedQuotaID;
      obj.userId = JSON.parse(localStorage.getItem("data")).userID;
      obj.decisionCode = decisionCode;
      obj.modificationId = 0;
      obj.sceanrioName = selectedScenario;
      //console.log(obj);
      dispatch(StickToQuota(obj)).then(() =>
        dispatch(GetQuotaDetailsForScenario(newObj))
      );
    }
  };

  const DoNothing = () => {
    let obj = {};
    let customerList = [];
    const newObj = {
      scenarioId: selectedScenarioID,
      quotaId: selectedQuotaID,
    };
    //console.log(rowSelectionModel);
    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (row["orderStatus"].toLowerCase() == "blocked") {
        customerList.push(row.customerQuotaID);
      }
      if(row.isBlockedOverNormal === 1 && row["orderStatus"].toLowerCase() == "blocked"){
        showMessage("Decision cannot be made as a blocked order has been placed above a normal order.", "info");
        return;
      }
      // customerList.push(row["id"]);
    }
    if (customerList.length == 0) {
      console.log("Please select blocked customer(s)");
      showMessage("Please select blocked customer(s)", "info");
      return;
    } else {
      obj.countryId = getScenarios.find(
        (x) => x.scenarioID === newObj.scenarioId
      ).geoID;
      obj.scenarioId = selectedScenarioID;
      obj.sceanrioName = selectedScenarioName;
      obj.blockedcustomers = customerList;
      obj.quotaId = selectedQuotaID;
      obj.userId = JSON.parse(localStorage.getItem("data")).userID;
      obj.decisionCode = "ND";
      obj.modificationId = 0;
      obj.sceanrioName = selectedScenario;
      //console.log(obj);
      dispatch(DoNothingMarked(obj)).then(() =>
        dispatch(GetQuotaDetailsForScenario(newObj))
      );
    }
  };

  const ModifySQ = () => {
    let customerList = [];
    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (row["orderStatus"].toLowerCase() == "blocked") {
        customerList.push(row.customerQuotaID);
      }
      if(row.isBlockedOverNormal === 1 && row["orderStatus"].toLowerCase() == "blocked"){
        showMessage("Decision cannot be made as a blocked order has been placed above a normal order.", "info");
        return;
      }
      // customerList.push(row["id"]);
    }
    if (customerList.length == 0) {
      console.log("Please select blocked customer(s)");
      showMessage("Please select blocked customer(s)", "info");
      return;
    }
    dispatch(setState("isModifyClicked", true));
    dispatch(setState("onUnblockClicked", false));
    dispatch(setState("onMSQClicked", true));
    dispatch(setState("isCurrentWeekRowChanged", false));
    dispatch(setState("customerListForDecision", []));
    dispatch(setState("customerListForDecisionSubmission", []));
    let obj = {
      blockedcustomers: customerList,
      countryId: getScenarios.find((x) => x.scenarioID === selectedScenarioID)
        .geoID,
      isDisplayOnlyBlockedOrder: 1,
      sceanrioName: selectedScenarioName,
      scenarioId: selectedScenarioID,
      selectedNumberOfDays: 1,
    };
    dispatch(GetBlockedCustomersConsumptionforMSQDecision(obj)).then(() => {

    });
  };

  const UnblockFullOrder = () => {
    let customerList = [];
    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (row["orderStatus"].toLowerCase() == "blocked") {
        customerList.push(row.customerQuotaID);
      }
      // customerList.push(row["id"]);
      if(row.isBlockedOverNormal === 1 && row["orderStatus"].toLowerCase() == "blocked"){
        showMessage("Decision cannot be made as a blocked order has been placed above a normal order.", "info");
        return;
      }
    }
    if (customerList.length == 0) {
      console.log("Please select blocked customer(s)");
      showMessage("Please select blocked customer(s)", "info");
      return;
    }
    dispatch(setState("isModifyClicked", true));
    dispatch(setState("onUnblockClicked", true));
    dispatch(setState("onMSQClicked", false));
    dispatch(setState("isCurrentWeekRowChanged", false));
    dispatch(setState("customerListForDecision", []));
    dispatch(setState("customerListForDecisionSubmission", []));
    let obj = {
      blockedcustomers: customerList,
      countryId: getScenarios.find((x) => x.scenarioID === selectedScenarioID)
        .geoID,
      isDisplayOnlyBlockedOrder: 1,
      sceanrioName: selectedScenarioName,
      scenarioId: selectedScenarioID,
      selectedNumberOfDays: 1,
    };
    dispatch(GetBlockedCustomersConsumptionforDecision(obj)).then(() => {});
  };

  useEffect(() => {
    if (onUnblockClicked) {
      if (customerListForDecision?.length > 0) {
        let customerListDecision = JSON.parse(
          JSON.stringify(customerListForDecision)
        );
        let customerList = [];
        for (let i = 0; i < rowSelectionModel.length; i++) {
          const row = rows.find(
            (row) => row.customerQuotaID === rowSelectionModel[i]
          );
          if (row["orderStatus"].toLowerCase() == "blocked") {
            customerList.push(row.customerQuotaID);
          }
        }
        dispatch(setState("selectedCustomersForDecision", customerList));
        dispatch(setState("onUnblockClicked", true));
        dispatch(setState("isCurrentWeekRowChanged", false));
        let quotaDetailslist = JSON.parse(JSON.stringify(getQuotaDetails));
        let idxs = -1;
        for (let i = 0; i < customerList.length; i++) {
          let details = {};
          for (let j = 0; j < customerListForDecision.length; j++) {
            let Ind = customerListForDecision[j].details.findIndex(
              (x) => Number(x.customerQuotaId) === Number(customerList[i])
            );
            if (Ind > -1) {
              details = customerListForDecision[j].details[Ind];
              idxs = j;
              break;
            }
          }
          let idx = quotaDetailslist.quotaCusumptionCustomers.findIndex(
            (x) => x.customerQuotaID === Number(customerList[i])
          );
          let detailedOrders = customerListDecision[idxs].details.filter(
            (x) => Number(x.customerQuotaId) === Number(customerList[i]) && x.isBlocked.toLowerCase() === 'yes'
          );
          let IntendedQuantity = 
            detailedOrders.reduce((sum, item) => sum + Number(item.intendedQtyUoM), 0);
          let AvailableQuota =
            quotaDetailslist.quotaCusumptionCustomers[idx].intendedQuantity;
          let TotalQuota =
            AvailableQuota +
            quotaDetailslist.quotaCusumptionCustomers[idx].consumption;
          // let NotBlocked = detailedOrders.filter(item=> item.isBlocked === 'No');
          // if(NotBlocked.length > 0) {
          //   let NotBlockedCustomersConsumtion = 
          //   detailedOrders.filter(item => item.isBlocked === 'No').reduce((sum, item) => sum + Number(item.availableQuota), 0);
          //   AvailableQuota = TotalQuota -  quotaDetailslist.quotaCusumptionCustomers[idx].consumption + NotBlockedCustomersConsumtion;
          //   //quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM  = AvQuotaForCal;
          // }
          if (currentWeek === 1) {
            if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].newFinalQuota.weekly1 = TotalQuota;
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].deltaModification.weekly1 =
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly1 -
                quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                  .weekly1;
            } else {
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].newFinalQuota.weekly1 = TotalQuota;
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].deltaModification.weekly1 =
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly1 -
                quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                  .weekly1;
              if (
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly2 <
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly1
              ) {
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly2 =
                  quotaDetailslist.quotaCusumptionCustomers[
                    idx
                  ].newFinalQuota.weekly1;
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].deltaModification.weekly2 =
                  quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                    .weekly2 -
                  quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                    .weekly2;
              }
              if (
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly3 <
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly2
              ) {
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly3 =
                  quotaDetailslist.quotaCusumptionCustomers[
                    idx
                  ].newFinalQuota.weekly2;
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].deltaModification.weekly3 =
                  quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                    .weekly3 -
                  quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                    .weekly3;
              }
              if (
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly4 <
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly3
              ) {
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly4 =
                  quotaDetailslist.quotaCusumptionCustomers[
                    idx
                  ].newFinalQuota.weekly3;
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].deltaModification.weekly4 =
                  quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                    .weekly4 -
                  quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                    .weekly4;
              }
              if (
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly5 <
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly4
              ) {
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly5 =
                  quotaDetailslist.quotaCusumptionCustomers[
                    idx
                  ].newFinalQuota.weekly4;
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].deltaModification.weekly5 =
                  quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                    .weekly5 -
                  quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                    .weekly5;
              }
            }
          } else if (currentWeek === 2) {
            quotaDetailslist.quotaCusumptionCustomers[
              idx
            ].newFinalQuota.weekly2 = TotalQuota;
            quotaDetailslist.quotaCusumptionCustomers[
              idx
            ].deltaModification.weekly2 =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly2 -
              quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                .weekly2;
            if (
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly3 <
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly2
            ) {
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].newFinalQuota.weekly3 =
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly2;
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].deltaModification.weekly3 =
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly3 -
                quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                  .weekly3;
            }
            if (
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly4 <
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly3
            ) {
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].newFinalQuota.weekly4 =
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly3;
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].deltaModification.weekly4 =
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly4 -
                quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                  .weekly4;
            }
            if (
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly5 <
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly4
            ) {
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].newFinalQuota.weekly5 =
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly4;
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].deltaModification.weekly5 =
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly5 -
                quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                  .weekly5;
            }
          } else if (currentWeek === 3) {
            quotaDetailslist.quotaCusumptionCustomers[
              idx
            ].newFinalQuota.weekly3 = TotalQuota;
            quotaDetailslist.quotaCusumptionCustomers[
              idx
            ].deltaModification.weekly3 =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly3 -
              quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                .weekly3;
            if (
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly4 <
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly3
            ) {
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].newFinalQuota.weekly4 =
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly3;
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].deltaModification.weekly4 =
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly4 -
                quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                  .weekly4;
            }
            if (
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly5 <
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly4
            ) {
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].newFinalQuota.weekly5 =
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly4;
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].deltaModification.weekly5 =
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly5 -
                quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                  .weekly5;
            }
          } else if (currentWeek === 4) {
            quotaDetailslist.quotaCusumptionCustomers[
              idx
            ].newFinalQuota.weekly4 = TotalQuota;
            quotaDetailslist.quotaCusumptionCustomers[
              idx
            ].deltaModification.weekly4 =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly4 -
              quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                .weekly4;
            if (
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly5 <
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly4
            ) {
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].newFinalQuota.weekly5 =
                quotaDetailslist.quotaCusumptionCustomers[
                  idx
                ].newFinalQuota.weekly4;
              quotaDetailslist.quotaCusumptionCustomers[
                idx
              ].deltaModification.weekly5 =
                quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                  .weekly5 -
                quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                  .weekly5;
            }
          } else if (currentWeek === 5) {
            quotaDetailslist.quotaCusumptionCustomers[
              idx
            ].newFinalQuota.weekly5 = TotalQuota;
            quotaDetailslist.quotaCusumptionCustomers[
              idx
            ].deltaModification.weekly5 =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly5 -
              quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
                .weekly5;
          }
          for (let i = 0; i < detailedOrders.length; i++) {
            let Ratio =
              detailedOrders[i].intendedQtyUoM /
              (IntendedQuantity);
            // detailedOrders[i].modifiedQtyPacks = Math.trunc(
            //   packConversion * Ratio
            // );
            // detailedOrders[i].modifiedQtyUoM =
            //   detailedOrders[i].modifiedQtyPacks * packSize;
            //detailedOrders[i].intendedQtyUoM = detailedOrders[i].intendedQtyUoM;
            detailedOrders[i].intendedQtyPacks = Math.round(detailedOrders[i].intendedQtyUoM/detailedOrders[i].packSize);
            detailedOrders[i].modifiedQtyUoM = Math.round(
              AvailableQuota * Ratio
            );
            if (detailedOrders[i].modifiedQtyUoM > detailedOrders[i].intendedQtyUoM)
            {
              detailedOrders[i].modifiedQtyUoM = detailedOrders[i].intendedQtyUoM;
            }
           
            detailedOrders[i].modifiedQtyPacks = Math.round(
              detailedOrders[i].modifiedQtyUoM / detailedOrders[i].packSize
            );
            detailedOrders[i].modifiedQtyUoM = Math.ceil(detailedOrders[i].modifiedQtyPacks *
              detailedOrders[i].packSize);
          }
          let sumModifiedQuantity = detailedOrders.reduce((sum, item) => sum + Number(item.modifiedQtyUoM), 0);
          quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM = sumModifiedQuantity;
        }
        dispatch(setState("ModifiedList", quotaDetailslist));
        dispatch(
          setState(
            "updatedWeeklyData",
            quotaDetailslist?.quotaCusumptionCustomers
          )
        );
        dispatch(
          setState("customerListForDecisionSubmission", customerListDecision)
        );
        //////////////to be changed here
        if (rowSelectionModel?.length === quotaConsumptionTableState?.length) {
          let detailsList = [];
          for (let r = 0; r < quotaConsumptionTableState?.length; r++) {
            detailsList.push(
              quotaDetailslist.quotaCusumptionCustomers.find(
                (x) =>
                  x.customerQuotaID ===
                  quotaConsumptionTableState[r].customerQuotaID
              )
            );
          }
          dispatch(setState("modifyList", detailsList));
          dispatch(setState("CustomerSearchTxt", searchCustomer));
          dispatch(setState("ProductSearchTxt", searchProduct));
          dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
        } else {
          dispatch(
            setState("modifyList", quotaDetailslist?.quotaCusumptionCustomers)
          );
          dispatch(setState("CustomerSearchTxt", ""));
          dispatch(setState("ProductSearchTxt", ""));
          dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
        }
        dispatch(setState("displayModification", true));
        setIsModificationOpened(true);
      }
    } else if (onMSQClicked) {
      if (customerListForDecision?.length > 0) {
        let customerList = [];
        let customerListDecision = JSON.parse(
          JSON.stringify(customerListForDecision)
        );
        for (let i = 0; i < rowSelectionModel.length; i++) {
          const row = rows.find(
            (row) => row.customerQuotaID === rowSelectionModel[i]
          );
          if (row["orderStatus"].toLowerCase() == "blocked") {
            customerList.push(row.customerQuotaID);
          }
        }
        dispatch(setState("selectedCustomersForDecision", customerList));
        let quotaDetailslist = JSON.parse(JSON.stringify(getQuotaDetails));
        let idxs = -1;
        for (let i = 0; i < customerList.length; i++) {
          let details = {};
          for (let j = 0; j < customerListForDecision.length; j++) {
            let Ind = customerListForDecision[j].details.findIndex(
              (x) => Number(x.customerQuotaId) === Number(customerList[i])
            );
            if (Ind > -1) {
              details = customerListForDecision[j].details[Ind];
              idxs = j;
              break;
            }
          }
          let packSize = details.packSize;
          let idx = quotaDetailslist.quotaCusumptionCustomers.findIndex(
            (x) => x.customerQuotaID === Number(customerList[i])
          );
          let quota = 0;
          if (currentWeek === 1)
            quota =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly1;
          if (currentWeek === 2)
            quota =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly2;
          if (currentWeek === 3)
            quota =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly3;
          if (currentWeek === 4)
            quota =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly4;
          if (currentWeek === 5)
            quota =
              quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
                .weekly5;

          let availableQuota =
            quota - quotaDetailslist.quotaCusumptionCustomers[idx].consumption;
          let detailedOrders = customerListDecision[idxs].details.filter(
            (x) => Number(x.customerQuotaId) === Number(customerList[i]) && x.isBlocked.toLowerCase() === 'yes'
          );
          let IntendedQuantity = 
          detailedOrders.reduce((sum, item) => sum + Number(item.intendedQtyUoM), 0);
          // let NotBlocked = detailedOrders.filter(item=> item.isBlocked === 'No');
          // if(NotBlocked.length > 0) {
          //   let NotBlockedCustomersConsumtion = 
          //   detailedOrders.filter(item => item.isBlocked === 'No').reduce((sum, item) => sum + Number(item.availableQuota), 0);
          //   availableQuota = quota -  quotaDetailslist.quotaCusumptionCustomers[idx].consumption + NotBlockedCustomersConsumtion;
          //   //quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM  = AvQuotaForCal;
          // }
          for (let i = 0; i < detailedOrders.length; i++) {
            let Ratio =
              detailedOrders[i].intendedQtyUoM /
              (IntendedQuantity);
            detailedOrders[i].intendedQtyPacks = Math.round(detailedOrders[i].intendedQtyUoM/packSize);
            detailedOrders[i].modifiedQtyUoM = Math.round(
              availableQuota * Ratio
            );
            if (detailedOrders[i].modifiedQtyUoM > detailedOrders[i].intendedQtyUoM)
            {
              detailedOrders[i].modifiedQtyUoM = detailedOrders[i].intendedQtyUoM;
            }
            detailedOrders[i].modifiedQtyPacks = Math.round(
              detailedOrders[i].modifiedQtyUoM / detailedOrders[i].packSize
            );
            detailedOrders[i].modifiedQtyUoM = Math.ceil(detailedOrders[i].modifiedQtyPacks *
              detailedOrders[i].packSize);
          }
          let sumModifiedQuantity = detailedOrders.reduce((sum, item) => sum + Number(item.modifiedQtyUoM), 0);
          quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM = sumModifiedQuantity;
        }
        dispatch(setState("ModifiedList", quotaDetailslist));
        dispatch(
          setState(
            "updatedWeeklyData",
            quotaDetailslist?.quotaCusumptionCustomers
          )
        );
        dispatch(
          setState("customerListForDecisionSubmission", customerListDecision)
        );

        if (rowSelectionModel?.length === quotaConsumptionTableState?.length) {
          let detailsList = [];
          for (let r = 0; r < quotaConsumptionTableState?.length; r++) {
            detailsList.push(
              quotaDetailslist.quotaCusumptionCustomers.find(
                (x) =>
                  x.customerQuotaID ===
                  quotaConsumptionTableState[r].customerQuotaID
              )
            );
          }
          dispatch(setState("modifyList", detailsList));
          dispatch(setState("CustomerSearchTxt", searchCustomer));
          dispatch(setState("ProductSearchTxt", searchProduct));
          dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
        } else {
          dispatch(
            setState("modifyList", quotaDetailslist?.quotaCusumptionCustomers)
          );
          dispatch(setState("CustomerSearchTxt", ""));
          dispatch(setState("ProductSearchTxt", ""));
          dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
        }
        dispatch(setState("displayModification", true));
        setIsModificationOpened(true);
      }
    }
  }, [customerListForDecision]);

  let visibleColumns = [];

  let arr = ["weekly2", "weekly3", "weekly4", "weekly5"];
  if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
    visibleColumns = columns.filter(
      (col) =>
        col.field !== "weekly2" &&
        col.field !== "weekly3" &&
        col.field !== "weekly4" &&
        col.field !== "weekly5"
    );
  } else if (getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly") {
    visibleColumns = columns.filter(
      (col) =>
        col.field !== "weekly3" &&
        col.field !== "weekly4" &&
        col.field !== "weekly5"
    );
  } else {
    visibleColumns = columns;
  }

  const handleBlockedOrders = () => {
    let customerList = [];
    let isBlocked = 0;
    let blockedCount = 0;
    let reviewedCount = 0;

    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (
        row["orderStatus"].toLowerCase() == "blocked" ||
        row["orderStatus"].toLowerCase() == "blocked and reviewed"
      ) {
        customerList.push(row.customerQuotaID);
      }
      if (row["orderStatus"].toLowerCase() == "blocked") {
        isBlocked = 1;
        blockedCount++;
        dispatch(setState("isReviewed", 0));
      } else if (row["orderStatus"].toLowerCase() == "blocked and reviewed") {
        isBlocked = 0;
        reviewedCount++;
        dispatch(setState("isReviewed", 1));
      }
      if(row.isBlockedOverNormal === 1 && row["orderStatus"].toLowerCase() == "blocked"){
        showMessage("Action cannot be taken as a blocked order has been placed above a normal order.", "info");
        return;
      }
      // customerList.push(row["id"]);
    }
    if (customerList.length == 0) {
      console.log("Please select blocked customer(s)");
      showMessage("Please select blocked customer(s)", "info");
      return;
    }

    if (blockedCount > 0 && reviewedCount > 0) {
      console.log("Please select either blocked or reviewed customer(s)");
      showMessage(
        "Please select either blocked or reviewed customer(s)",
        "info"
      );
      return;
    }

    let obj = {
      blockedcustomers: customerList,
      countryId: getScenarios.find((x) => x.scenarioID === selectedScenarioID)
        .geoID,
      isDisplayOnlyBlockedOrder: isBlocked,
      sceanrioName: selectedScenarioName,
      scenarioId: selectedScenarioID,
      selectedNumberOfDays: 1,
    };
    let newObj = {
      blockedcustomers: customerList,
      countryId: getScenarios.find((x) => x.scenarioID === selectedScenarioID)
        .geoID,
      isDisplayOnlyBlockedOrder: isBlocked,
      sceanrioName: selectedScenarioName,
      scenarioId: selectedScenarioID,
      selectedNumberOfDays: 1,
      selectedQuotaID: selectedQuotaID,
    };
    dispatch(setState("orderParameters", newObj));
    //console.log(obj);
    dispatch(GetBlockedCustomersConsumption(obj));
    handleOpen();
    dispatch(setState("openModifyOrders", true));
  };

  const getRowClassName = (params) => {
    return params.row.isBlockedOverNormal ? "blockedOverNormal-row" : params.row.isModified ? "modified-row" : "";
  };

  useEffect(() => {
    if (omIsDisplayBlocked) {
      setIsDisplayBlockedCustomers(true);
    }
  }, [omIsDisplayBlocked]);

  return (
    <div>
      <Box mt={2}>
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>

        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="subtitle1">
              Scenario of : {selectedScenario}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Search Customer"
              value={searchCustomer}
              onChange={handleSearchCustomer}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
              fullWidth
              size="small"
            ></TextField>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Search Product"
              value={searchProduct}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
              onChange={handleSearchProduct}
              fullWidth
              size="small"
            ></TextField>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <FormControlLabel
              label="List Only Blocked Customers"
              control={
                <Checkbox
                  checked={isDisplayBlockedCustomers}
                  onChange={(e) =>
                    setIsDisplayBlockedCustomers(e.target.checked)
                  }
                  //onChange = {handleisDisplayBlocked}
                />
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3}>
            {getQuotaDetails?.quotaCusumptionCustomers?.length > 0 && <ExportIcons isQuotaConsumption={true} />}
          </Grid>
        </Grid>
        {getQuotaDetails?.quotaCusumptionCustomers?.length > 0 && (
          <Box sx={{ mt: 3 }} ref={QCRef}>
            <DataGrid
              style={{ maxHeight: "calc(100vh - 130px)" }}
              rows={rows || []}
              columns={visibleColumns}
              getRowId={(row) => row?.customerQuotaID}
              sx={{
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  fontWeight: "bold !important",
                  fontSize: "14px",
                  fontFamily: "Montserrat, Sans-serif",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "normal",
                  fontWeight: "bold",
                  fontSize: "14px",
                  fontFamily: "Montserrat, Sans-serif",
                },
                "& .MuiDataGrid-columnHeader": {
                  // Forced to use !important since overriding inline styles
                  height: "unset !important",
                  backgroundColor: "rgba(235, 246, 250)",
                },
                "& .MuiDataGrid-columnHeaders": {
                  // Forced to use !important since overriding inline styles
                  maxHeight: "168px !important",
                },
                "& .MuiDataGrid-row": {
                  backgroundColor: "none !important",
                },
                "& .Mui-selected": {
                  backgroundColor: "none !important",
                },
              }}
              pageSizeOptions={[20, 50, 100]}
              // paginationMode="client"
              // initialState={{
              //     pagination: { paginationModel: { pageSize:20, page:0 }}
              // }}
              //rowSelectionModel={rowSelectionModel}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              checkboxSelection={true}
              disableRowSelectionOnClick
              disableColumnMenu
              onRowSelectionModelChange={(newRowSelectionModel) => {
                console.log(newRowSelectionModel);
                setRowSelectionModel(newRowSelectionModel);
              }}
              getRowClassName={getRowClassName}
              headerHeight={40}
              //onColumnHeaderClick={handleHeaderCellClick}
              //onRowClick={handleRowClick}
            />
          </Box>
        )}

        <Box mt={3}>
          <Grid
            container
            columns={6}
            justifyContent="flex-end"
            spacing={2}
            pb={2}
          >
            <Grid item xs={6} sm={1} md={1} lg={0.8}>
              <Button
                startIcon={<EditIcon />}
                sx={{ minWidth: 200, height: 45 }}
                variant="contained"
                id="SearchButton"
                disabled={!isRestrictedAccess}
                style={{
                  // background: "#286aa6",
                  color: "white",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                onClick={handleBlockedOrders}
              > 
                Edit Blocked Orders
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={0.8} lg={0.65}>
              <Button
                startIcon={<LabelImportantRoundedIcon />}
                sx={{ minWidth: 120, height: 45 }}
                variant="contained"
                id="SearchButton"
                disabled={!isRestrictedAccess}
                style={{
                  // background: "#286aa6",
                  color: "white",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                onClick={() => SaveOrderDecision("stick")}
              >
                Stick to quota
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={1.18} lg={0.9}>
              <Button
                startIcon={<DownloadDoneRoundedIcon />}
                sx={{ height: 45 }}
                variant="contained"
                id="SearchButton"
                disabled={!isRestrictedAccess || !getQuotaDetails?.modifyStickToQuota}
                onClick={() => ModifySQ()}
                style={{
                  // background: "#286aa6",
                  color: "white",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                //onClick={DisplayDiv}
              >
                Modify + Stick to Quota{" "}
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={1} lg={0.8}>
              <Button
                startIcon={<LockOpenRoundedIcon />}
                sx={{ height: 45 }}
                disabled={!isRestrictedAccess || !getQuotaDetails?.unblockFullOrder}
                style={{
                  // background: "#286aa6",
                  color: "white",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                variant="contained"
                id="SearchButton"
                onClick={UnblockFullOrder}
              >
                Unblock full order
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={0.6} lg={0.5}>
              <Button
                //startIcon={<LockOpenRoundedIcon />}
                sx={{ height: 45 }}
                disabled={!isRestrictedAccess}
                style={{
                  background: "rgba(235, 246, 250)",
                  color: "#286aa6",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                onClick={() => DoNothing()}
                variant="outlined"
                id="SearchButton"
                // onClick={DisplayDiv}
              >
                <strong>Do Nothing</strong>
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={0.8} lg={0.7}>
              <Box justifyContent="center" display="flex">
                <Button
                  sx={{ height: 45 }}
                  startIcon={<EditIcon />}
                  variant="contained"
                  onClick={handleRetrive}
                  size="large"
                  disabled={
                    getQuotaDetails?.isModified &&
                    (getQuotaDetails?.status.toLowerCase() === "submitted" ||
                      getQuotaDetails?.status.toLowerCase() ===
                        "locally approved")
                      ? true
                      : false
                  }
                  // className="mui_Button"
                  //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
                >
                  Modify Quota
                </Button>
              </Box>
            </Grid>

            <Grid item xs={6} sm={2} md={0.8} lg={0.8}>
              <Box justifyContent="center">
                <Button
                  disabled={
                    getQuotaDetails?.isModified &&
                    (getQuotaDetails?.status.toLowerCase() === "submitted" ||
                      getQuotaDetails?.status.toLowerCase() ===
                        "locally approved")
                      ? false
                      : true
                  }
                  sx={{
                    height: 45,
                    visibility:
                      getQuotaDetails?.isModified &&
                      (getQuotaDetails?.status.toLowerCase() === "submitted" ||
                        getQuotaDetails?.status.toLowerCase() ===
                          "locally approved")
                        ? "visible"
                        : "none",
                  }}
                  startIcon={<EditIcon />}
                  variant="contained"
                  onClick={handleRecallModification}
                  size="large"
                  // className="mui_Button"
                  //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
                >
                  Recall Modification
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <ModifyOrders />
    </div>
  );
};

export default QuotaandConsumption;
